import React, { useEffect, useState, useRef } from 'react';
import { IoIosClose } from 'react-icons/io';
import './index.scss';


const DrawerNavigator = (props) => {
    const { onClick, onBlur, isOpen } = props;

    const openClass =  isOpen ? "open":"";
    return (
        <>
            <div className={`drawer-navigator-wrapper ${openClass}`}>
                <div className={`backdrop ${openClass}`} onClick={onBlur}></div>
                <div className={`overlay ${openClass}`}>
                    <div className="item right">
                        <IoIosClose onClick={onBlur} className="clickable"/>
                    </div>
                    <div className="item" onClick={onClick.bind(this, 'home')}>
                        Home
                    </div>
                    <div className="item" onClick={onClick.bind(this, 'gallery')}>
                        Gallery
                    </div>
                    <div className="item" onClick={onClick.bind(this, 'portfolio')}>
                        Portfolio
                    </div>
                    <div className="item" onClick={onClick.bind(this, 'about')}>
                        About
                    </div>
                    <div className="item" onClick={onClick.bind(this, 'contact')}>
                        Contact
                    </div>
                </div>
            </div>
        </>
    );
};

export default DrawerNavigator;